module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-f3ed405f811b1de171f2525f7fc6339d.png";